import { useState } from "react";
import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";
import ProgramRichForm from "../components/ProgramRichForm";
import Procedures from "./Procedures";
import Communication from "./Communication";

const TABS = [
  { key: "objectives", label: "Objetivos" },
  { key: "aia", label: "Matrices AIA" },
  { key: "lifecycle", label: "Ciclo de Vida" },
  { key: "procedures", label: "Procedimientos" },
  { key: "inspections", label: "Inspecciones" },
  { key: "communication", label: "Competencia y Comunicación" },
];

export default function ISO14001() {
  const [tab, setTab] = useState("objectives");
  return (
    <div data-testid="iso-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>ISO 14001 / SGA</h1>
        <PDFButton endpoint="/pdf/module/iso_objectives" filename="reporte_iso.pdf" label="Reporte PDF" />
      </div>
      <div className="tabs-bar">
        {TABS.map((t) => (
          <button key={t.key} className={`tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)} data-testid={`iso-tab-${t.key}`}>{t.label}</button>
        ))}
      </div>
      {tab === "objectives" && (
        <ProgramRichForm collection="iso_objectives" testIdPrefix="iso-objectives" title="Objetivo Ambiental" extraFields={[
          { key: "purpose", label: "Propósito esperado", type: "textarea", full: true },
          { key: "goal", label: "Meta cuantitativa" },
          { key: "indicator", label: "Indicador" },
        ]} />
      )}
      {tab === "aia" && (
        <CrudTable
          collection="aia_matrices"
          testIdPrefix="aia"
          fields={[
            { key: "process_area", label: "Proceso/Área", required: true },
            { key: "leader", label: "Líder" },
            { key: "responsible", label: "Responsable" },
            { key: "status", label: "Status", type: "select", options: ["No iniciado", "En revisión", "Aprobada"] },
            { key: "last_update", label: "Última actualización", type: "date" },
          ]}
        />
      )}
      {tab === "lifecycle" && (
        <CrudTable
          collection="iso_objectives"
          filters={{ category: "lifecycle" }}
          testIdPrefix="lifecycle"
          fields={[
            { key: "name", label: "Etapa del ciclo de vida", required: true, full: true },
            { key: "description", label: "Descripción", type: "textarea", full: true },
            { key: "responsible", label: "Responsable" },
            { key: "status", label: "Status", type: "select", options: ["Documentado", "En análisis", "Pendiente"] },
            { key: "category", label: "Categoría", default: "lifecycle", hiddenInForm: true, hidden: true },
          ]}
        />
      )}
      {tab === "procedures" && (
        <Procedures embedded />
      )}
      {tab === "inspections" && (
        <CrudTable
          collection="inspections"
          testIdPrefix="iso-inspections"
          fields={[
            { key: "date", label: "Fecha", type: "date" },
            { key: "area", label: "Área" },
            { key: "auditor", label: "Auditor" },
            { key: "score", label: "% Cumplimiento", type: "number" },
            { key: "status", label: "Status", type: "select", options: ["Pendiente", "Ejecutada", "Cerrada"] },
          ]}
        />
      )}
      {tab === "communication" && <Communication embedded />}
    </div>
  );
}
